module.exports = __webpack_public_path__ + "static/media/view.d319b0ef.svg";